import { render, staticRenderFns } from "./InterestContactsPage.vue?vue&type=template&id=2c7ea0d2&scoped=true&"
import script from "./InterestContactsPage.vue?vue&type=script&lang=js&"
export * from "./InterestContactsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7ea0d2",
  null
  
)

export default component.exports